export const TOPICTYPE_TASK = 1;
export const TOPICTYPE_BILL = 2;
export const TOPICTYPE_ANALYS = 3;
export const TOPICTYPE_RENDER = 4;
export const TOPICTYPE_PAY_SUCCESS = 5;
export const TOPICTYPE_FULLSPEEDCOMPLETE_OR_STOP = 6;
export const TOPICTYPE_PAY_HAS_SCANNED = 7;
export const TOPICTYPE_BALANCE_AND_COUPON = 9;

export enum TopicType {
  Task = 1,
  Bill,
  Analys,
  Render,
  PaySuccess,
  BalanceAndCoupon = 9,
  FullSpeedCompleteOrStop = TOPICTYPE_FULLSPEEDCOMPLETE_OR_STOP,
  CloneSubmitFail = 34,
  SystemNotice = 90,
  FetchPlatformStatus = 91,
}
